import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Tooltip from 'components/Tooltip'

import ErrorIcon from 'assets/icons/error-input-trailing-icon'
import InfoIcon from 'assets/icons/info-icon16px'

import { InputField, Label, Error, TrailingIconsContainer, TrailingIcon, InputContainer, InputHint } from './style'

const tooltipXOffset = 0
const tooltipYOffset = -16
const Input = ({
  field,
  value = '',
  label,
  link,
  hyper,
  onChange,
  onBlur,
  type = 'text',
  placeholder = '',
  error,
  trailingIcon,
  trailingIconAction,
  hint,
  margin,
  height = '48px',
  dataTest,
  disabled,
  infoTooltip = '',
  zIndex,
  marginBottomLabel,
  marginBottomInput,
  errorMarginTop = '16px',
  isOptional = false,
  dataTestId,
  title,
  labelTitle,
  readOnly = false,
}) => {
  const intl = useIntl()
  const tooltipLabel = labelTitle || label

  return (
    <InputContainer data-testid='test-input-container' margin={margin} marginBottomInput={marginBottomInput}>
      {React.isValidElement(label)
        ? label
        : label && (
          <Label data-test={`label-${dataTest}`} htmlFor={`input-${field}`} marginBottomLabel={marginBottomLabel}>
            <section style={{ display: 'flex', alignItems: 'center' }}>
              <span title={labelTitle ? intl.formatMessage({ id: labelTitle }) : undefined}>
                <FormattedMessage id={label} />
              </span>
              {infoTooltip && (
                <div className='tooltipArrowTop'>
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    zIndex={zIndex}
                    placement='top'
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                    overlay={{ label: tooltipLabel, infoTooltip: infoTooltip }}
                    link={link}
                    hyper={hyper}
                  >
                    <div>
                      <InfoIcon />
                    </div>
                  </Tooltip>
                </div>
              )}
            </section>
            <span>{isOptional && <FormattedMessage id='optional' />}</span>
          </Label>
        )}
      <div style={{ position: 'relative' }}>
        {readOnly ? (
          <InputField
            data-testid={dataTestId ? dataTestId : 'test-input'}
            id={`input-${field}`}
            type={type}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder=''
            error={error && error.field === field}
            height={height}
            data-test={dataTest}
            readOnly={readOnly}
            disabled={disabled}
            title={title}
          />
        ) : (
          <FormattedMessage id={placeholder}>
            {(placeHolder) => {
              return (
                <InputField
                  data-testid={dataTestId ? dataTestId : 'test-input'}
                  id={`input-${field}`}
                  type={type}
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  placeholder={placeHolder}
                  error={error && error.field === field}
                  height={height}
                  data-test={dataTest}
                  disabled={disabled}
                  title={title}
                />
              )
            }}
          </FormattedMessage>
        )}
        <TrailingIconsContainer>
          {trailingIcon && <TrailingIcon onClick={trailingIconAction}>{trailingIcon}</TrailingIcon>}
          {error && error.field === field && (
            <TrailingIcon data-test='icon-validation-error'>
              <ErrorIcon />
            </TrailingIcon>
          )}
        </TrailingIconsContainer>
      </div>
      {hint && error.field !== field && (
        <InputHint data-test='validation-error-message'>
          <FormattedMessage id={hint} />
        </InputHint>
      )}
      {error && error.field === field && (
        <Error errorMarginTop={errorMarginTop} data-test='validation-error-message'>
          <FormattedMessage id={error.error} />
        </Error>
      )}
    </InputContainer>
  )
}

export default Input
